import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Location} from '@angular/common';
import { JwtHelperService } from '@auth0/angular-jwt';

import { Auth } from 'aws-amplify';
import { BehaviorSubject, catchError, Observable, of, switchMap, throwError } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../models/user';


@Injectable({
    providedIn: 'root'
})
export class AuthService {
    _jwtHelper = new JwtHelperService();
    
    // Track login state changes
    private isLoggedInSubject = new BehaviorSubject<boolean>(false);
    public isLoggedIn$ = this.isLoggedInSubject.asObservable();

    constructor(
        private _router: Router,
        private _route: ActivatedRoute,
        private _httpClient: HttpClient,
        private _location: Location
        // private _httpBackedn: HttpBacked
    ) {
        // Check initial auth state
        this.checkAndUpdateAuthState();
    }
    
    // Check and update the auth state
    async checkAndUpdateAuthState(): Promise<void> {
        try {
            const user = await Auth.currentUserInfo();
            this.isLoggedInSubject.next(!!user);
        } catch (error) {
            this.isLoggedInSubject.next(false);
        }
    }

    // Notify when user logs in
    notifyLogin(): void {
        this.isLoggedInSubject.next(true);
    }

    // Notify when user logs out
    notifyLogout(): void {
        this.isLoggedInSubject.next(false);
    }

    set accessToken(token: string) {
        localStorage.setItem('accessToken', token);
    }

    set idToken(token: string) {
        localStorage.setItem('idToken', token);
    }

    set refreshToken(token: string) {
        localStorage.setItem('refreshToken', token);
    }

    set user(user: any) {
        localStorage.setItem('user', user);
    }

    get accessToken(): string {
        return localStorage.getItem('accessToken') ?? '';
    }

    get idToken(): string {
        return localStorage.getItem('idToken') ?? '';
    }

    get isTokenExpired(): boolean {
        return this._jwtHelper.isTokenExpired(this.accessToken);
    }

    get user(): any {
        const user = localStorage.getItem('user');
        return user ? JSON.parse(user) : null;
    }

    public clearLocalStorage() {
        localStorage.clear();
        localStorage.removeItem('user');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('idToken');
    }

    public getUser(): Promise<any> {
        return Auth.currentUserInfo();
    }

    public getCurrentSession(): Promise<any> {
        return Auth.currentSession();
    }

    public getCurrentCredentials(): Promise<any> {
        return Auth.currentCredentials();
    }

    public signOut(): Promise<any> {
        return Auth.signOut();
    }

    public signIn(username: string, password:string): Promise<any> {
      return Auth.signIn(username, password)
    }

    public signUp(user: User): Promise<any> {
        // The issue might be that the User Pool Client is configured for OAuth only
        // Let's try the most basic signup possible
        console.log('Attempting basic signup for:', user.email);
        
        return Auth.signUp({
            username: user.email,
            password: user.pass
        }).catch((error) => {
            console.error('Basic signup failed:', error);
            if (error.code === 'NotAuthorizedException' && error.message.includes('unauthorized attribute')) {
                console.log('Client appears to be OAuth-only. Consider using Cognito Hosted UI for signup.');
                throw new Error('This app may be configured for OAuth-only signup. Please contact support.');
            }
            throw error;
        });
    }

    public confirmSignUp(user: User): Promise<any> {
        return Auth.confirmSignUp(user.email, user.otp);
    }

    public check(): Observable<boolean> {
        return new Observable(subscriber => {
            this.getCurrentSession()
                .then(session => {
                    console.log('sessions => ', session)
                    subscriber.next(true);
                })
                .catch(error => subscriber.next(false));
        });
    }

    public async navigatedTo(authenticated:any) {
        console.log('CCCCCCCCCCCCCCCCCCC',this._location.path())
        if (authenticated && !this._router.url.includes('home')) {
            // setTimeout(() => {
                // Navigate to the current route
              await  this._router.navigate([this._location.path()]);
            // }, 10)
        }
        else if (!authenticated || this._router.url.includes('home')) {
            // setTimeout(() => {
                this._router.navigate(['/']);
            // }, 10)
        }
        // if(!authenticated) {
        //     // If the user is not authenticated, regardless of the page they are trying to access,
        // // redirect them to the home page.
        // this._router.navigate(['/home']);
        // }
    }
}
